module.exports = __webpack_public_path__ + "static/media/GenesisResearch_BulbLogo_WhiteBackground_square.8c1791a7.png";